// @ts-nocheck
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { hasFinancistAccess } from '../lib/roleFinancialAccess'
import '../components/RoleSelector.css'

export const FkspSelectRole: React.FC = () => {
  const navigate = useNavigate()
  const { user } = useAuth()

  // Доступные роли в зависимости от прав
  const canBePersonalista = user?.role === 'personalista' || (user?.role === 'admin' && user?.admin_type === 'spravce_it')
  const canBeZocmos = user?.role === 'zocmos' || (user?.role === 'admin' && user?.admin_type === 'spravce_it')
  const canBeDirector = user?.role === 'director' || (user?.role === 'admin' && user?.admin_type === 'spravce_it')
  const canBeEkonom = hasFinancistAccess(user)
  const isITAdmin = user?.role === 'admin' && user?.admin_type === 'spravce_it'

  const getRoleLabel = (role: string | null) => {
    if (!role) return 'Bez role'
    switch (role) {
      case 'director':
        return 'Ředitel'
      case 'financist':
        return 'Hlavní ekonom'
      case 'referent_eko':
        return 'Referent EKO'
      case 'personalista':
        return 'Personalista'
      case 'zocmos':
        return 'ZO ČMOS'
      default:
        return role
    }
  }

  const handleRoleClick = (role: 'requester' | 'personalista' | 'zocmos' | 'director' | 'ekonom') => {
    switch (role) {
      case 'requester':
        navigate('/fksp')
        break
      case 'personalista':
        if (!canBePersonalista) {
          alert('Nemáte oprávnění k přístupu jako Personalista.')
          return
        }
        navigate('/fksp/personalista')
        break
      case 'zocmos':
        if (!canBeZocmos) {
          alert('Nemáte oprávnění k přístupu jako ZO ČMOS.')
          return
        }
        navigate('/fksp/zocmos')
        break
      case 'director':
        if (!canBeDirector) {
          alert('Nemáte oprávnění k přístupu jako Ředitel.')
          return
        }
        navigate('/fksp/director')
        break
      case 'ekonom':
        if (!canBeEkonom) {
          alert('Nemáte oprávnění k přístupu jako Hlavní ekonom.')
          return
        }
        navigate('/fksp/ekonom')
        break
    }
  }

  return (
    <div className="role-selector">
      <div className="role-selector-container">
        <button 
          className="back-to-roles-button"
          onClick={() => navigate('/intranet')}
          style={{ marginBottom: '1rem' }}
        >
          ← Zpět
        </button>
        <h1>Žádosti FKSP</h1>
        <p className="subtitle">Vyberte svou roli pro přístup k systému</p>
        
        <div className="role-buttons">
          <button 
            className="role-button"
            onClick={() => handleRoleClick('requester')}
          >
            <h2>Žadatel</h2>
            <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
              Podat žádost o příspěvek FKSP (benefity nebo připojištění) a sledovat stav.
              Vedoucí, hlavní ekonom, správce budov/IT a správce jídelny mohou podat žádost i jménem podřízených.
            </p>
          </button>
          
          <button 
            className={`role-button ${!canBePersonalista ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('personalista')}
            disabled={!canBePersonalista}
            title={!canBePersonalista ? 'Nemáte oprávnění jako Personalista' : ''}
          >
            <h2>Personalista</h2>
            <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
              První krok schvalování všech žádostí FKSP (benefity i připojištění).
            </p>
            {!canBePersonalista && <span className="disabled-badge">Nedostupné</span>}
          </button>
          
          <button 
            className={`role-button ${!canBeZocmos ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('zocmos')}
            disabled={!canBeZocmos}
            title={!canBeZocmos ? 'Nemáte oprávnění jako ZO ČMOS' : ''}
          >
            <h2>ZO ČMOS (Odbory)</h2>
            <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
              Vyjádření odborové organizace k přijatým žádostem o příspěvek z FKSP.
            </p>
            {!canBeZocmos && <span className="disabled-badge">Nedostupné</span>}
          </button>
          
          <button 
            className={`role-button ${!canBeDirector ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('director')}
            disabled={!canBeDirector}
            title={!canBeDirector ? 'Nemáte oprávnění jako Ředitel' : ''}
          >
            <h2>Ředitel</h2>
            <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
              Finální schvalování žádostí a generování tiskových PDF.
            </p>
            {!canBeDirector && <span className="disabled-badge">Nedostupné</span>}
          </button>

          <button
            className={`role-button ${!canBeEkonom ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('ekonom')}
            disabled={!canBeEkonom}
            title={!canBeEkonom ? 'Nemáte oprávnění jako Hlavní ekonom' : ''}
          >
            <h2>Hlavní ekonom</h2>
            <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
              Přehled žádostí po schválení ředitelem — náhled a stažení PDF.
            </p>
            {!canBeEkonom && <span className="disabled-badge">Nedostupné</span>}
          </button>

          {isITAdmin && (
            <button
              type="button"
              className="role-button"
              onClick={() => navigate('/fksp/smazane')}
              style={{ borderColor: '#dc2626', color: '#991b1b' }}
            >
              <h2>Smazané žádosti</h2>
              <p style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '8px', lineHeight: 1.4 }}>
                Archiv soft-smazaných žádostek FKSP — pouze správce IT.
              </p>
            </button>
          )}
        </div>
        
        {user && (
          <div style={{ 
            marginTop: '2rem', 
            padding: '1rem 1.5rem', 
            background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)', 
            borderRadius: '12px',
            color: 'white',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }}>
            <p style={{ margin: 0, fontSize: '1rem', fontWeight: '500' }}>
              <strong>{user.name}</strong>
              {user.admin_type && (
                <span style={{ marginLeft: '0.5rem', opacity: 0.9 }}>
                  • {user.admin_type === 'spravce_it' ? 'Správce IT' : 'Správce Budov'}
                </span>
              )}
              {!user.admin_type && user.role !== 'admin' && (
                <span style={{ marginLeft: '0.5rem', opacity: 0.9 }}>
                  • {getRoleLabel(user.role)}
                </span>
              )}
              {isITAdmin && (
                <span style={{ marginLeft: '0.5rem', fontSize: '0.9rem', opacity: 0.95 }}>
                  ✅ Přístup ke všem rolím
                </span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
